<router-outlet></router-outlet>

<anon-cookies-popup></anon-cookies-popup>
